import { createSelector } from 'reselect'
import getPathnameRouterSelect from 'modules/router/selectors/get-pathname/index.js'

export const isPlanUrlRouterSelect = createSelector(
  getPathnameRouterSelect,
  (pathname) => /plans\//gi.test(pathname)
)
